import { render, staticRenderFns } from "./dashboard-module-shared-widgets-print-labels-widget.vue?vue&type=template&id=d45f3a56&scoped=true&"
import script from "./dashboard-module-shared-widgets-print-labels-widget.ts?vue&type=script&lang=ts&"
export * from "./dashboard-module-shared-widgets-print-labels-widget.ts?vue&type=script&lang=ts&"
import style0 from "./dashboard-module-shared-widgets-print-labels-widget.scss?vue&type=style&index=0&id=d45f3a56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45f3a56",
  null
  
)

export default component.exports